import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=bba80efa&"
import script from "./OtpInput.vue?vue&type=script&lang=ts&"
export * from "./OtpInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports